<template>
  <div>
    <ai-report-top-container />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AiReportTopContainer from "@/container/ai-report/AiReportTopContainer.vue";

export default defineComponent({
  components: { AiReportTopContainer },
});
</script>
